//Validación del TextArea "Describa su problema"
const validateProblem = (problem) => {
  var texto = problem.value.replace(/\s+/g, "");
  //Variable para mostrar los errores de cada validación
  const errors = {};
  //Si el TextArea está vacío deshabilita el botón y muestra un error marcando el input en color rojo
  if (problem.value === "") {
    document.getElementById("submitButton").disabled = true;
    errors[problem.problema] =
      problem.required || "Descripción es obligatoria.";
    document.getElementById("problem").className =
      "fuente form-control is-invalid";
    document.getElementById("submitButton").className =
      "btn btn-secondary mb-2";
  // } else if (document.getElementById("area").value === "Área" &&
  //     document.getElementById("asunto").className !== "fuente form-control is-valid" &&
  //     document.getElementById("file").value === "") {
  //   document.getElementById("submitButton").disabled = true
  //   document.getElementById("submitButton").className =
  //     "btn btn-secondary fuente mb-2"
  // } else if (document.getElementById("area").value === "Área" &&
  //     document.getElementById("asunto").className === "fuente form-control is-valid" &&
  //     document.getElementById("file").value === "") {
  //   document.getElementById("submitButton").disabled = true
  //   document.getElementById("submitButton").className =
  //     "btn btn-secondary fuente mb-2"
  }

  //Si los caracteres ingresados son menor al mínimo (20), deshabilita el botón y muestra un error marcando el input en color rojo
  else if (texto.length < problem.min) {
    errors[problem.problema] =
      problem.maxValue || "No hay información suficiente para crear el Ticket.";
    document.getElementById("submitButton").disabled = true;
    document.getElementById("problem").className =
      "fuente form-control is-invalid";
    document.getElementById("submitButton").className =
      "btn btn-secondary fuente mb-2";
  }

  //Si los caracteres ingresados son mayor al máximo (250), deshabilita el botón y muestra un error marcando el input en color rojo
  else if (texto.length > problem.max) {
    errors[problem.problema] =
      problem.shortValue ||
      "El limite de caracteres ha sido excedido, favor reducir el número de caracteres.";
    document.getElementById("submitButton").disabled = true;
    document.getElementById("problem").className =
      "fuente form-control is-invalid";
    document.getElementById("submitButton").className =
      "btn btn-secondary fuente mb-2";
  } else {
    //Si estas validaciones no se cumplen muestra el TextArea en Verde y procede con las validaciones del siguiente campo
    document.getElementById("problem").className = "fuente form-control is-valid";

    if (document.getElementById("area").value === "Otros" &&
        document.getElementById("asunto").className !== "fuente form-control") {
      document.getElementById("submitButton").disabled = true
      document.getElementById("submitButton").className =
        "btn btn-secondary fuente mb-2"
    } else if (document.getElementById("area").value === "Otros" &&
        document.getElementById("asunto").className !== "fuente form-control is-valid") {
      document.getElementById("submitButton").disabled = true
      document.getElementById("submitButton").className =
        "btn btn-secondary fuente mb-2"
    }
    else if (document.getElementById("area").value === "Aplicaciones" &&
    document.getElementById("asunto").className !== "fuente form-control" &&
    document.getElementById("file").value === "") {
      document.getElementById("submitButton").disabled = true
      document.getElementById("submitButton").className =
        "btn btn-secondary fuente mb-2"
    } else if (document.getElementById("area").value === "Aplicaciones" &&
    document.getElementById("asunto").className !== "fuente form-control is-valid" &&
    document.getElementById("file").value === "") {
      document.getElementById("submitButton").disabled = true
      document.getElementById("submitButton").className =
        "btn btn-secondary fuente mb-2"
    } else {
      document.getElementById("submitButton").disabled = false;
      document.getElementById("submitButton").className =
        "btn btn-primary fuente mb-2";
    }

    if (document.getElementById("area").value === "Otros" &&
        document.getElementById("problem").className === "fuente form-control is-valid" &&
        document.getElementById("file").value === "") {
      document.getElementById("submitButton").disabled = false
      document.getElementById("submitButton").className =
        "btn btn-primary fuente mb-2"
    } else if (document.getElementById("area").value === "Otros" &&
        document.getElementById("problem").className === "fuente form-control is-valid" &&
        document.getElementById("file").value !== "") {
      document.getElementById("submitButton").disabled = false
      document.getElementById("submitButton").className =
        "btn btn-primary fuente mb-2"
    }
  }
  return errors;
};

let filesArch = [];

//Validación del Input File  "Adjunte Imágenes"
function validateFile(file) {
  const errors = {}; //Variable para mostrar los errores de cada validación
  var ValArea = document.getElementById("area").value; //Variable para almacenar el valor del DropDown "Con que tienes problemas?"
  var ValAsunto = document.getElementById("asunto").value;
  var valFile = document.getElementById("file"); //Almacena las propiedades del Input File
  var files = document.getElementById("file").files.length; //Contiene la cantidad de registros en el array del file
  var archivo = document.getElementById("file").files; //Muestra el array del Input File
  filesArch = [];

  if (document.getElementById("file").value === "") {
    clearImages();
  }

  if (filesArch.length === 5) {
    document.getElementById("submitButton").disabled = true;
    document.getElementById("submitButton").className =
      "btn btn-secondary fuente mb-2";
    errors.file =
      file.shortValue || "El máximo de archivos adjuntados ha sido excedido.";
    clearImages();
    if (document.getElementById("file").value === "") {
      clearImages();
    }
  } else {
    //Contador para el ciclo for
    //Ciclo para recorrer cada una de las imágenes subidas por el usuario y validarlas
    for (let x = 0; x < archivo.length; x++) {
      // Obtener la extensión del archivo actual
      let extension = archivo[x].name.split('.').pop().toLowerCase();

      if (extension === "eml") {
        // Si la extensión es "eml", añade el archivo al array filesArch
        if (!filesArch.some((e) => e.name === archivo[x].name)) {
          filesArch.push(archivo[x]);
        }
        showImages(); // Actualiza la previsualización de los archivos
      }

      //Si la imagen cargada es diferente a las extensiones permitidas (png, jpg, jpeg), deshabilita el botón y muestra un error
      if (
        extension !== "png" &&
        extension !== "jpg" &&
        extension !== "jpeg" &&
        extension !== "pdf" &&
        extension !== "doc" &&
        extension !== "docx" &&
        extension !== "xls" &&
        extension !== "eml" &&
        extension !== "xlsx"
      ) {
        valFile.value = "";
        document.getElementById("submitButton").disabled = true;
        document.getElementById("submitButton").className =
          "btn btn-secondary fuente mb-2";
        errors.file =
          file.validFile || "El archivo esta en un formato no soportado.";
        clearImages();
        if (document.getElementById("file").value === "") {
          clearImages();
        }

        //Valida si la cantidad de imagenes subidas por el usuario son mayores al máximo (5), deshabilita el botón y muestra un mensaje de error
      } else if (files > file.max && archivo.length > 5) {
        document.getElementById("submitButton").disabled = true;
        document.getElementById("submitButton").className =
          "btn btn-secondary fuente mb-2";
        errors.file =
          file.shortValue ||
          "El máximo de archivos adjuntados ha sido excedido.";
        clearImages();
        if (document.getElementById("file").value === "") {
          clearImages();
        }

        //Si el DropDown es igual "Aplicaciones" envía los atributos al Input File para que este sea obligatorio y permita subir multiples archivos
        //Si el Input File no está vacío y el problema si lo está, deshabilita el botón.
      } else if (
        ValArea === "Aplicaciones" &&
        ValArea === "" &&
        file.value !== "" &&
        document.getElementById("problem").className === "form-control"
      ) {
        document.getElementById("submitButton").disabled = true;
        document.getElementById("submitButton").className =
          "btn btn-secondary fuente mb-2";
        valFile.setAttribute("required", true);
        valFile.setAttribute("multiple",true);

        //Si el DropDown es igual "Aplicaciones" envía los atributos al Input File para que este sea obligatorio y permita subir multiples archivos
        //Si el Input File no está vacío habilita el botón
      } else if (
        ValArea === "Aplicaciones" && ValAsunto !== "" &&
        file.value !== "" &&
        document.getElementById("problem").className !==
        "form-control is-valid"
      ) {
        document.getElementById("submitButton").disabled = false;
        document.getElementById("submitButton").className =
          "btn btn-primary fuente mb-2";
        valFile.setAttribute("required", true);
        valFile.setAttribute("multiple",true);

        //Si el DropDown es igual "Otros" quita los atributos al Input File para que no sea obligatorio y multiple luego habilita el botón
      } else if (ValArea === "Otros" && ValAsunto !== "" && 
      file.value !== "" &&
      document.getElementById("problem").className ===
      "form-control is-valid") {
        filesArch = [];
        valFile.removeAttribute("required");
        valFile.setAttribute("multiple",true);
        document.getElementById("submitButton").disabled = false;
        document.getElementById("submitButton").className =
          "btn btn-primary fuente mb-2";

        //Si el TextArea "Describa su problema" no está vacío
      } else if (document.getElementById("problem").value !== "") {
        //Y no está en color rojo habilita el botón
        if (
          document.getElementById("problem").className !==
          "fuente form-control is-invalid"
        ) {
          document.getElementById("submitButton").disabled = false;
          document.getElementById("submitButton").className =
            "btn btn-primary fuente mb-2";
        }
      } else if (document.getElementById("asunto").value !== "") {
        //Y no está en color rojo habilita el botón
        if (
          document.getElementById("asunto").className !==
          "fuente form-control is-invalid"
        ) {
          document.getElementById("submitButton").disabled = false;
          document.getElementById("submitButton").className =
            "btn btn-primary fuente mb-2";
        }
      }

      //Si el DropDown es igual "Aplicaciones" y el problema está vacío deshabilita el botón
      else if (
        ValArea === "Aplicaciones" && ValAsunto !== "" &&
        document.getElementById("problem").value === ""
      ) {
        //Y no está en color rojo habilita el botón
        if (document.getElementById("problem").style.backgroundColor === "") {
          document.getElementById("submitButton").disabled = true;
          document.getElementById("submitButton").className =
            "btn btn-secondary fuente mb-2";
        }

        //Si estas validaciones no se cumplen muestra un error y deshabilita el botón
      } else if (
        ValArea === "Aplicaciones" && ValAsunto !== "" &&
        document.getElementById("file").value === ""
      ) {
        document.getElementById("submitButton").disabled = true;
        document.getElementById("submitButton").className =
          "btn btn-secondary fuente mb-2";
      } else {
        document.getElementById("submitButton").disabled = true;
        document.getElementById("submitButton").className =
          "btn btn-secondary fuente mb-2";
        errors.file = file.required !== "Imágenes son requeridas.";
      }

      if (
        ValArea === "Aplicaciones" &&
        document.getElementById("file").value !== "" &&
        document.getElementById("asunto").value !==
        "fuente form-control is-invalid" &&
        document.getElementById("problem").className !==
        "fuente form-control is-invalid"
      ) {
        if (
          archivo[x].type.split("/")[0] !== "image" &&
          archivo[x].type.split("/")[0] !== "application"
        )
          continue;
        if (!filesArch.some((e) => e.name === archivo[x].name))
          filesArch.push(archivo[x]);
        showImages();
      }

      if (
        ValArea === "Otros" &&
        document.getElementById("file").value !== "" &&
        document.getElementById("asunto").className !==
        "fuente form-control is-invalid" &&
        document.getElementById("problem").className !==
        "fuente form-control is-invalid"
      ) {
        if (
          archivo[x].type.split("/")[0] !== "image" &&
          archivo[x].type.split("/")[0] !== "application"
        )
          continue;
        if (!filesArch.some((e) => e.name === archivo[x].name))
          filesArch.push(archivo[x]);

        showImages();
      }
    }
  }
  return errors;
}

// Validación del TextArea "Describa su problema"
const validateAsunto = (asunto) => {
  const errors = {}
  var texto = asunto.value.replace(/\s+/g, ""),
    valid = /[`¡!@#$%^&*()_+\=\[\]{};´¨':"\\|<>\/¿?°~]/;
  if (asunto.value === "") {
    errors[asunto.asunto] =
      asunto.required || "Este campo es obligatorio.";
    document.getElementById("asunto").className = "fuente form-control is-invalid";
    document.getElementById("submitButton").className = "btn btn-secondary mb-2";
    document.getElementById("submitButton").disabled = true;
  }
  else if (texto.length < asunto.min) {
    errors[asunto.asunto] =
      asunto.maxValue || "Falta de caracteres en este campo (Mínimo 5). Favor ingresar más detalles.";
    document.getElementById("submitButton").disabled = true
    document.getElementById("submitButton").className =
      "btn btn-secondary mb-2"
    document.getElementById("asunto").className = "form-control is-invalid";
  } else if (texto.length > asunto.max) {
    errors.asunto =
      asunto.shortValue || "Se ha excedido el limite de carácteres en este campo (Máximo 100).";
    document.getElementById("asunto").className = "form-control is-invalid";
    document.getElementById("submitButton").disabled = true;
    document.getElementById("submitButton").className = "btn btn-secondary mb-2"; 
  } else if (valid.test(asunto.value)) {
    errors[asunto.asunto] =
      asunto.validAsunto || "Error, Favor ingresar solo caracteres alfabéticos.";
    document.getElementById("asunto").className = "form-control is-invalid";
    document.getElementById("submitButton").disabled = true;
    document.getElementById("submitButton").className =
      "btn btn-secondary mb-2";
    document.getElementById("asunto").className = "form-control is-invalid";
  } else {
    document.getElementById("asunto").className = "fuente form-control is-valid";

    if (document.getElementById("area").value === "Otros" &&
        document.getElementById("problem").className !== "fuente form-control") {
      document.getElementById("submitButton").disabled = true
      document.getElementById("submitButton").className =
        "btn btn-secondary fuente mb-2"
    } else if (document.getElementById("area").value === "Otros" &&
        document.getElementById("problem").className !== "fuente form-control is-valid") {
      document.getElementById("submitButton").disabled = true
      document.getElementById("submitButton").className =
        "btn btn-secondary fuente mb-2"
    }
    else if (document.getElementById("area").value === "Aplicaciones" &&
    document.getElementById("problem").className !== "fuente form-control" &&
    document.getElementById("file").value === "") {
      document.getElementById("submitButton").disabled = true
      document.getElementById("submitButton").className =
        "btn btn-secondary fuente mb-2"
    } else if (document.getElementById("area").value === "Aplicaciones" &&
    document.getElementById("problem").className !== "fuente form-control is-valid" &&
    document.getElementById("file").value === "") {
      document.getElementById("submitButton").disabled = true
      document.getElementById("submitButton").className =
        "btn btn-secondary fuente mb-2"
    }else {
      document.getElementById("submitButton").disabled = false;
      document.getElementById("submitButton").className =
        "btn btn-primary fuente mb-2";
    }

    if (document.getElementById("area").value === "Otros" &&
        document.getElementById("problem").className === "fuente form-control is-valid" &&
        document.getElementById("file").value === "") {
      document.getElementById("submitButton").disabled = false
      document.getElementById("submitButton").className =
        "btn btn-primary fuente mb-2"
    } else if (document.getElementById("area").value === "Otros" &&
        document.getElementById("problem").className === "fuente form-control is-valid" &&
        document.getElementById("file").value !== "") {
      document.getElementById("submitButton").disabled = false
      document.getElementById("submitButton").className =
        "btn btn-primary fuente mb-2"
    }
  }
  return errors;
}


/** SHOW IMAGES */
function showImages() {
  let container = document.querySelector(".containerImg");
  container.innerHTML = filesArch.reduce((prev, curr, index) => {
    if (curr.type === "application/pdf") {
      return `${prev}
          <div class='image'>	   
            <embed width="120px" height="80px" src="${URL.createObjectURL(curr)}" type="application/pdf" />	
            <span id='img-close${index}'>&times;</span>      
            <p>${curr.name}</p>        
          </div>`;
    } else if (curr.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
      return `${prev}
          <div class='image'>      
            <div class="fa fa-file-excel-o fa-lg" width="150px" height="80px" style="color: #1d6b41; justify-content: center; display:flex; margin-top: 12%;"></div>
            <span id='img-close${index}'>&times;</span>      
            <p>${curr.name}</p>        
          </div>`;
    } else if (curr.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document") {
      return `${prev}
            <div class='image'>                  
            <div class="fa fa-file-word-o fa-lg" width="150px" height="80px" style="color: #28518f; justify-content: center; display:flex; margin-top: 12%;"></div>
              <span id='img-close${index}'>&times;</span>      
              <p>${curr.name}</p>        
            </div>`;
    } else if (curr.type === "message/rfc822") {
      return `${prev}
        <div class='image'>                  
          <div class="fa fa-envelope-o fa-lg" style="color: #D44638; justify-content: center; display:flex; margin-top: 12%;"></div>
          <span id='img-close${index}'>&times;</span>      
          <p>${curr.name}</p>        
        </div>`;
    }
    else {
      return `${prev}
          <div class='image'>                  
            <img width="120px" height="90px" src="${URL.createObjectURL(curr)}" />	
            <span id='img-close${index}'>&times;</span>      
            <p>${curr.name}</p>        
          </div>`;
    }
  }, "");

  for (let x = 0; x < filesArch.length; x++) {
    document
      .getElementById("img-close" + x)
      .addEventListener("click", function borrar() {
        filesArch.splice(x, 1);
        removeFileFromFileList(x);
        showImages();
      });
  }
}

function removeFileFromFileList(index) {
  const dt = new DataTransfer();
  const input = document.getElementById("file");
  const { files } = input;

  for (let i = 0; i < files.length; i++) {
    const file = files[i];
    if (index !== i) dt.items.add(file); // here you exclude the file. thus removing it.
  }

  input.files = dt.files; // Assign the updates list
  if (document.getElementById("file").value === "") {
    if (document.getElementById("area").value === "Aplicaciones") {
      clearImages();
      document.getElementById("file").setAttribute("required", true);
      document.getElementById("submitButton").disabled = true;
      document.getElementById("submitButton").className =
        "btn btn-secondary fuente mb-2";
    }

    if (document.getElementById("area").value === "Otros") {
      clearImages();
      document.getElementById("file").removeAttribute("required");
      document.getElementById("submitButton").disabled = false;
      document.getElementById("submitButton").className =
        "btn btn-primary fuente mb-2";
    }
    else if (filesArch[index].type === "message/rfc822") {
      filesArch.splice(index, 1);
      showImages();
    }

  }
}

/** CLEAR IMAGES */
function clearImages() {
  filesArch = [];
  let container = document.querySelector(".containerImg");
  container.innerHTML = filesArch.reduce((prev, curr, index) => {
    return `${prev}
        <div class='image'>	
          <img width="120px" height="80px" src="${URL.createObjectURL(curr)}" />	
          <span id='img-close${index}'>&times;</span>      
          <p>${curr.name}</p>        
        </div>`;
  }, "");
  document.getElementById("file").value = "";
  document.getElementById("file").removeAttribute("required");
}

function Limpiar() {
  filesArch = [];
  let container = document.querySelector(".containerImg");
  container.innerHTML = filesArch.reduce((prev, curr, index) => {
    return `${prev}
        <div class='image'>	
          <img width="120px" height="80px" src="${URL.createObjectURL(curr)}" />	
          <span id='img-close${index}'>&times;</span>      
          <p>${curr.name}</p>        
        </div>`;
  }, "");
  document.getElementById("file").value = "";
}

//Exportación de las validaciones para poder usar en los componentes
module.exports = {
  validateProblem,
  validateFile,
  validateAsunto,
  showImages,
  filesArch,
  clearImages,
  Limpiar,
};